var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"HistoriesView"}},[_c('HistoriesStaff')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }